import React from "react"
import "./PHeader.css"
import { TypeAnimation } from 'react-type-animation'

const PHeader = () => {
  return (
    <>
      <div className="pmain-div">
        <div className="pheader-top">
          <div className="pheader">
            <div className="pheader-content">
              <TypeAnimation
                className="pheading"
                sequence={[
                  `YOUR HOME \nIN THE PARK`,
                  20000
                ]}
                speed={200}
                style={{ whiteSpace: 'pre-wrap' }}
                cursor={false}
              />

              {/* <h3>YOUR HOME IN THE PARK</h3> */}
              {/* <p>
              Residential Apartments Located in the Heart of Bahria Town, Lahore.
            </p> */}
              <TypeAnimation
                className="pdes"
                sequence={[
                  `Built on Vision, Delivered with Discipline`,
                  20000
                ]}
                speed={150}
                style={{ whiteSpace: 'pre-wrap' }}
                cursor={false}
              />
            </div>
          </div>
        </div>
        <div className="pheadermobileview">
          <div className="pheadermobileview-img">
            <img src="./ParkPhotos/Header/header.webp" alt="building" />
          </div>
          <div className="pheadermobileview-content">
            <TypeAnimation
              className="pmobileviewheading"
              sequence={[
                `YOUR HOME \nIN THE PARK`,
                20000
              ]}
              speed={200}
              style={{ whiteSpace: 'pre-wrap' }}
              cursor={false}
            />
            {/* <h3>YOUR HOME <br />IN THE PARK</h3> */}
            {/* <p>
            Residential Apartments Located In The Heart of Bahria Town, Lahore.
          </p> */}
            <TypeAnimation
              className="pmobileviewdes"
              sequence={[
                `Built on Vision, Delivered with Discipline`,
                20000
              ]}
              speed={150}
              style={{ whiteSpace: 'pre-wrap' }}
              cursor={false}
            />
          </div>
        </div>
      </div>
    </>

  );
};

export default PHeader
